import { DialogClose } from '@radix-ui/react-dialog';
import { Button } from '@design-system/button';
import { DialogBody, DialogFooter, DialogHeader } from '@design-system/dialog';
import type { FC } from 'react';
import { useRef } from 'react';

const CancelSubscriptionDialog: FC<{ onSuccess: () => void }> = ({
  onSuccess,
}) => {
  const closeRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <DialogHeader>Cancel Subscription</DialogHeader>
      <DialogBody className='flex justify-center items-center flex-col'>
        <p className='text-center text-gray-800 whitespace-pre-line'>
          Are you sure you want to cancel your subscription? This action cannot
          be undone.
        </p>
      </DialogBody>
      <DialogFooter className='sm:justify-center pt-0'>
        <DialogClose
          ref={closeRef}
          className='w-1/2'
        >
          <Button
            variant='primaryOutline'
            className='text-gray-800 border-pale-border w-full'
          >
            No, Close
          </Button>
        </DialogClose>
        <Button
          variant='danger'
          className='w-1/2'
          onClick={() => {
            onSuccess();
            closeRef.current?.click();
          }}
        >
          Yes, Cancel Subscription
        </Button>
      </DialogFooter>
    </>
  );
};

export default CancelSubscriptionDialog;
